import { missingField } from '@AMIEWEB/Notification/MultiChannel/Sms/CredentialingAnalyst/PlacementDisplay';
import i18next from 'i18next';
import { customSwitch } from 'utils/customSwitchCase/customSwitch';
import { Concatenate } from 'utils/string/string';

export const getInitials = (firstName: string, lastName: string) =>
  firstName && lastName ? Concatenate([firstName?.substring(0, 1), lastName?.substring(0, 1)], '') : missingField;

export const getPhoneNumber = contact =>
  contact && contact.phoneNumber
    ? Concatenate([contact.countryDialingCode ? '+' + contact.countryDialingCode : '+1', contact.phoneNumber], ' ')
    : '';

export const getKeyInternalPartnerContacts = placementDetails => ({
  recruiter: {
    designation: 'Recruiter',
    keyAttribute: 'recruiter',
    title: Concatenate([placementDetails?.recruiter?.firstName, placementDetails?.recruiter?.lastName], ' '),
    avatarText: getInitials(placementDetails?.recruiter?.firstName, placementDetails?.recruiter?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.recruiter),
    email: placementDetails?.recruiter?.email,
    id: placementDetails?.recruiter?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.recruiter?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.recruiter?.isDisabled || false,
  },
  accountManager: {
    designation: 'Account Manager',
    keyAttribute: 'accountManager',
    title: Concatenate([placementDetails?.accountManager?.firstName, placementDetails?.accountManager?.lastName], ' '),
    avatarText: getInitials(placementDetails?.accountManager?.firstName, placementDetails?.accountManager?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.accountManager),
    email: placementDetails?.accountManager?.email,
    id: placementDetails?.accountManager?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.accountManager?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.accountManager?.isDisabled || false,
  },
  regionalDirector: {
    designation: 'Regional Director',
    keyAttribute: 'regionalDirector',
    title: Concatenate(
      [placementDetails?.regionalDirector?.firstName, placementDetails?.regionalDirector?.lastName],
      ' ',
    ),
    avatarText: getInitials(
      placementDetails?.regionalDirector?.firstName,
      placementDetails?.regionalDirector?.lastName,
    ),
    phoneNumber: getPhoneNumber(placementDetails?.regionalDirector),
    email: placementDetails?.regionalDirector?.email,
    id: placementDetails?.regionalDirector?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.regionalDirector?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.regionalDirector?.isDisabled || false,
  },
  travelerContractCoordinator: {
    designation: 'Candidate Contracts',
    keyAttribute: 'travelerContractCoordinator',
    title: Concatenate(
      [placementDetails?.travelerContractCoordinator?.firstName, placementDetails?.travelerContractCoordinator?.lastName],
      ' ',
    ),
    avatarText: getInitials(
      placementDetails?.travelerContractCoordinator?.firstName,
      placementDetails?.travelerContractCoordinator?.lastName,
    ),
    phoneNumber: getPhoneNumber(placementDetails?.travelerContractCoordinator),
    email: placementDetails?.travelerContractCoordinator?.email,
    id: placementDetails?.travelerContractCoordinator?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.travelerContractCoordinator?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.travelerContractCoordinator?.isDisabled || false,
  },
  credentialingAnalyst: {
    designation: 'Credentialing Analyst',
    keyAttribute: 'credentialingAnalyst',
    title: Concatenate(
      [placementDetails?.credentialingAnalyst?.firstName, placementDetails?.credentialingAnalyst?.lastName],
      ' ',
    ),
    avatarText: getInitials(
      placementDetails?.credentialingAnalyst?.firstName,
      placementDetails?.credentialingAnalyst?.lastName,
    ),
    phoneNumber: getPhoneNumber(placementDetails?.credentialingAnalyst),
    email: placementDetails?.credentialingAnalyst?.email,
    id: placementDetails?.credentialingAnalyst?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.credentialingAnalyst?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.credentialingAnalyst?.isDisabled || false,
  },
  clientContractSpecialist: {
    designation: 'Client Contract Specialist',
    keyAttribute: 'clientContractSpecialist',
    title: Concatenate(
      [placementDetails?.clientContractSpecialist?.firstName, placementDetails?.clientContractSpecialist?.lastName],
      ' ',
    ),
    avatarText: getInitials(
      placementDetails?.clientContractSpecialist?.firstName,
      placementDetails?.clientContractSpecialist?.lastName,
    ),
    phoneNumber: getPhoneNumber(placementDetails?.clientContractSpecialist),
    email: placementDetails?.clientContractSpecialist?.email,
    id: placementDetails?.clientContractSpecialist?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.clientContractSpecialist?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.clientContractSpecialist?.isDisabled || false,
  },
  clinicalManager: {
    designation: 'Clinical Manager',
    keyAttribute: 'clinicalManager',
    title: Concatenate(
      [placementDetails?.clinicalManager?.firstName, placementDetails?.clinicalManager?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.clinicalManager?.firstName, placementDetails?.clinicalManager?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.clinicalManager),
    email: placementDetails?.clinicalManager?.email,
    id: placementDetails?.clinicalManager?.id,
    hideMessageIcon: true,
  },
  clientContractAdmin: {
    designation: 'Client Contract Admin',
    keyAttribute: 'clientContractAdmin',
    title: Concatenate(
      [placementDetails?.clientContractAdmin?.firstName, placementDetails?.clientContractAdmin?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.clientContractAdmin?.firstName, placementDetails?.clientContractAdmin?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.clientContractAdmin),
    email: placementDetails?.clientContractAdmin?.email,
    id: placementDetails?.clientContractAdmin?.id,
    hideMessageIcon: true,
  },
  payrollSpecialist: {
    designation: 'Payroll Specialist',
    keyAttribute: 'payrollSpecialist',
    title: Concatenate(
      [placementDetails?.payrollSpecialist?.firstName, placementDetails?.payrollSpecialist?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.payrollSpecialist?.firstName, placementDetails?.payrollSpecialist?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.payrollSpecialist),
    email: placementDetails?.payrollSpecialist?.email,
    id: placementDetails?.payrollSpecialist?.id,
    hideMessageIcon: true,
  },
  qsCoordinator: {
    designation: 'Credentialing Specialist',
    keyAttribute: 'qsCoordinator',
    title: Concatenate(
      [placementDetails?.qsCoordinator?.firstName, placementDetails?.qsCoordinator?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.qsCoordinator?.firstName, placementDetails?.qsCoordinator?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.qsCoordinator),
    email: placementDetails?.qsCoordinator?.email,
    id: placementDetails?.qsCoordinator?.id,
    hideMessageIcon: true,
    lockReason:
      placementDetails?.qsCoordinator?.disabledReason ||
      `${i18next.t('placement.profile.header.contactNotEditMessage')} ${missingField}`,
    disabled: placementDetails?.qsCoordinator?.isDisabled || false,
  },
  candidateSupportSpecialist: {
    designation: 'Customer Support Specialist',
    keyAttribute: 'candidateSupportSpecialist',
    title: Concatenate(
      [placementDetails?.candidateSupportSpecialist?.firstName, placementDetails?.candidateSupportSpecialist?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.candidateSupportSpecialist?.firstName, placementDetails?.candidateSupportSpecialist?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.candidateSupportSpecialist),
    email: placementDetails?.candidateSupportSpecialist?.email,
    id: placementDetails?.candidateSupportSpecialist?.id,
    hideMessageIcon: true,
  },
  timeProcessingSpecialist: {
    designation: 'Time Processing Specialist',
    keyAttribute: 'timeProcessingSpecialist',
    title: Concatenate(
      [placementDetails?.timeProcessingSpecialist?.firstName, placementDetails?.timeProcessingSpecialist?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.timeProcessingSpecialist?.firstName, placementDetails?.timeProcessingSpecialist?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.timeProcessingSpecialist),
    email: placementDetails?.timeProcessingSpecialist?.email,
    id: placementDetails?.timeProcessingSpecialist?.id,
    hideMessageIcon: true,
  },
  housingAccountExecutive: {
    designation: 'Housing Account Executive',
    keyAttribute: 'housingAccountExecutive',
    title: Concatenate(
      [placementDetails?.housingAccountExecutive?.firstName, placementDetails?.housingAccountExecutive?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.housingAccountExecutive?.firstName, placementDetails?.housingAccountExecutive?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.housingAccountExecutive),
    email: placementDetails?.housingAccountExecutive?.email,
    id: placementDetails?.housingAccountExecutive?.id,
    hideMessageIcon: true,
  },
  housingAccountingSpecialist: {
    designation: 'Housing Accounting Specialist',
    keyAttribute: 'housingAccountingSpecialist',
    title: Concatenate(
      [placementDetails?.housingAccountingSpecialist?.firstName, placementDetails?.housingAccountingSpecialist?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.housingAccountingSpecialist?.firstName, placementDetails?.housingAccountingSpecialist?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.housingAccountingSpecialist),
    email: placementDetails?.housingAccountingSpecialist?.email,
    id: placementDetails?.housingAccountingSpecialist?.id,
    hideMessageIcon: true,
  },
  directorOfRecruitment: {
    designation: 'Director Of Recruitment',
    keyAttribute: 'directorOfRecruitment',
    title: Concatenate(
      [placementDetails?.directorOfRecruitment?.firstName, placementDetails?.directorOfRecruitment?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.directorOfRecruitment?.firstName, placementDetails?.directorOfRecruitment?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.directorOfRecruitment),
    email: placementDetails?.directorOfRecruitment?.email,
    id: placementDetails?.directorOfRecruitment?.id,
    hideMessageIcon: true,
  },
  hamOpsManager: {
    designation: 'Director Of Account Management',
    keyAttribute: 'hamOpsManager',
    title: Concatenate(
      [placementDetails?.hamOpsManager?.firstName, placementDetails?.hamOpsManager?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.hamOpsManager?.firstName, placementDetails?.hamOpsManager?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.hamOpsManager),
    email: placementDetails?.hamOpsManager?.email,
    id: placementDetails?.hamOpsManager?.id,
    hideMessageIcon: true,
  },
  qsSupervisor: {
    designation: 'Credentialing Supervisor',
    keyAttribute: 'qsSupervisor',
    title: Concatenate(
      [placementDetails?.qsSupervisor?.firstName, placementDetails?.qsSupervisor?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.qsSupervisor?.firstName, placementDetails?.qsSupervisor?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.qsSupervisor),
    email: placementDetails?.qsSupervisor?.email,
    id: placementDetails?.qsSupervisor?.id,
    hideMessageIcon: true,
  },
  recruiterLiaisons: {
    designation: 'Recruitment Coordinator',
    keyAttribute: 'recruiterLiaisons',
    title: Concatenate(
      [placementDetails?.recruiterLiaisons?.firstName, placementDetails?.recruiterLiaisons?.lastName],
      ' ',
    ),
    avatarText: getInitials(placementDetails?.recruiterLiaisons?.firstName, placementDetails?.recruiterLiaisons?.lastName),
    phoneNumber: getPhoneNumber(placementDetails?.recruiterLiaisons),
    email: placementDetails?.recruiterLiaisons?.email,
    id: placementDetails?.recruiterLiaisons?.id,
    hideMessageIcon: true,
  }
});

export const placementContactsFlattened = placementDetails => ({
  placementId: placementDetails.placementId,
  facility: placementDetails.facility,
  recruiter: placementDetails.recruiter,
  accountManager: placementDetails.accountManager,
  regionalDirector: placementDetails.regionalDirector,
  travelerContractCoordinator: placementDetails.travelerContractCoordinator,
  credentialingAnalyst: placementDetails.credentialingAnalyst,
  clientContractSpecialist: placementDetails.clientContractSpecialist,
  clinicalManager: placementDetails.clinicalManager,
  clientContractAdmin: placementDetails.clientContractAdmin,
  payrollSpecialist: placementDetails.payrollSpecialist,
  qsCoordinator: placementDetails.qsCoordinator,
  candidateSupportSpecialist: placementDetails.candidateSupportSpecialist,
  timeProcessingSpecialist: placementDetails.timeProcessingSpecialist,
  housingAccountExecutive: placementDetails.housingAccountExecutive,
  housingAccountingSpecialist: placementDetails.housingAccountingSpecialist,
  directorOfRecruitment: placementDetails.directorOfRecruitment,
  hamOpsManager: placementDetails.hamOpsManager,
  qsSupervisor: placementDetails.qsSupervisor,
  recruiterLiaisons: placementDetails.recruiterLiaisons,
  facilityContacts: placementFacilityContactsDetails(placementDetails.facilityContacts),
  keyInternalPartners: getKeyInternalPartnerContacts(placementDetails),
  hideMessageIcon: true,
});

export const placementFacilityContactsDetails = facilityContacts =>
  facilityContacts.map(contact => ({
    ...contact,
    avatarText: getInitials(contact?.firstName, contact?.lastName),
    title: Concatenate([contact?.firstName, contact?.lastName], ' '),
    designation: contact?.title,
    description: Concatenate(
      contact?.actions?.map(action => action?.description),
      ', ',
    ),
    phoneNumber: getPhoneNumber(contact?.phoneNumber?.[0]),
    hideMessageIcon: true,
    hideAvatar: false,
    checked: false,
    hidePhoneIcon: contact?.phoneNumber?.length && contact?.doNotCall === 0 ? false : true,
  }));

export const getKeyContact = customSwitch({
  ['accountManager']: 1,
  ['recruiter']: 2,
  ['regionalDirector']: 3,
  ['credentialingAnalyst']: 4,
  ['clientContractSpecialist']: 5,
  ['qsCoordinator']: 6,
})(null);

export enum Brand {
  AMN_Nurse = 1,
  NursesRX = 2,
  Onward = 3,
  Preferred = 4,
  OGP_Travel = 5,
  Nursefinders = 6,
  TTS = 7,
  OGP_Intl = 8,
  NurseChoice = 9,
  AMN_Allied = 10,
  AMN_Advanced_Practitioner_Staffing = 11,
  Club_Staffing = 12,
  AMN_Labor_Disruption = 14,
}

export const isDisplayContractHours = (brandId?: Brand) => brandId === Brand.OGP_Travel || brandId === Brand.OGP_Intl;

export enum KeyContactType {
  Internal = 'isInternal',
  Client = 'isClient',
}
